const en_trans_stockopname = {
    "": "stock opname",
    add: "add stock opname",
    edit: "edit stock opname",
    detail: "stock opname detail",
    trans_id: "Stock Opname ID",

    label: {
        btn_download_list: "download item list",
        btn_fnsh: "finish stock opname",
        btn_approve_adj: "approve and adjust",
        btn_submit_adj: "submit adjustment",
    },

    message: {
        conf_finish_title: "Are you sure?",
        conf_finish_text: "Once saved, you will not be able to make any changes!",
    },

    error: {
        delete: "Failed to delete stock opname data",
        failed_download: "Failed to download file",
        not_found: "Stock opname data not found",
        submit: "Failed to save stock opname data",
    },

    success: {
        delete: "Stock opname data deleted successfully",
        submit: "Stock opname data saved successfully",
    },
}

export default en_trans_stockopname;